var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNyTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_2588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.885 120.73H103.199V124.389H106.885V120.73Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.201 124.391H99.5156V128.049H103.201V124.391Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.201 120.73H99.5156V124.389H103.201V120.73Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5138 124.391H95.8281V128.049H99.5138V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5138 120.73H95.8281V124.389H99.5138V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5138 95.1211H95.8281V98.7796H99.5138V95.1211Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8302 128.047H92.1445V131.705H95.8302V128.047Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8302 124.391H92.1445V128.049H95.8302V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8302 120.73H92.1445V124.389H95.8302V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8302 117.074H92.1445V120.733H95.8302V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8302 98.7812H92.1445V102.44H95.8302V98.7812Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8302 95.1211H92.1445V98.7796H95.8302V95.1211Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1427 128.047H88.457V131.705H92.1427V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1427 124.391H88.457V128.049H92.1427V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1427 120.73H88.457V124.389H92.1427V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1427 117.074H88.457V120.733H92.1427V117.074Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1427 98.7812H88.457V102.44H92.1427V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1427 95.1211H88.457V98.7796H92.1427V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1427 91.4648H88.457V95.1234H92.1427V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 131.707H84.7695V135.366H88.4552V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 128.047H84.7695V131.705H88.4552V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 124.391H84.7695V128.049H88.4552V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 120.73H84.7695V124.389H88.4552V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 117.074H84.7695V120.733H88.4552V117.074Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 113.414H84.7695V117.073H88.4552V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 102.438H84.7695V106.096H88.4552V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 98.7812H84.7695V102.44H88.4552V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 95.1211H84.7695V98.7796H88.4552V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 91.4648H84.7695V95.1234H88.4552V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4552 69.5117H84.7695V73.1703H88.4552V69.5117Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 131.707H81.0859V135.366H84.7717V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 128.047H81.0859V131.705H84.7717V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 124.391H81.0859V128.049H84.7717V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 120.73H81.0859V124.389H84.7717V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 117.074H81.0859V120.733H84.7717V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 113.414H81.0859V117.073H84.7717V113.414Z",
    fill: "#80D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 102.438H81.0859V106.096H84.7717V102.438Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 98.7812H81.0859V102.44H84.7717V98.7812Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 95.1211H81.0859V98.7796H84.7717V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 91.4648H81.0859V95.1234H84.7717V91.4648Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 73.1719H81.0859V76.8304H84.7717V73.1719Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7717 69.5117H81.0859V73.1703H84.7717V69.5117Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 131.707H77.3984V135.366H81.0842V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 128.047H77.3984V131.705H81.0842V128.047Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 124.391H77.3984V128.049H81.0842V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 120.73H77.3984V124.389H81.0842V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 117.074H77.3984V120.733H81.0842V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 113.414H77.3984V117.073H81.0842V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 109.758H77.3984V113.416H81.0842V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 102.438H77.3984V106.096H81.0842V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 98.7812H77.3984V102.44H81.0842V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 95.1211H77.3984V98.7796H81.0842V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 91.4648H77.3984V95.1234H81.0842V91.4648Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 87.8047H77.3984V91.4632H81.0842V87.8047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 73.1719H77.3984V76.8304H81.0842V73.1719Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 69.5117H77.3984V73.1703H81.0842V69.5117Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 65.8555H77.3984V69.514H81.0842V65.8555Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0842 51.2188H77.3984V54.8773H81.0842V51.2188Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 131.707H73.7148V135.366H77.4006V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 128.047H73.7148V131.705H77.4006V128.047Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 124.391H73.7148V128.049H77.4006V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 120.73H73.7148V124.389H77.4006V120.73Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 117.074H73.7148V120.733H77.4006V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 113.414H73.7148V117.073H77.4006V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 109.758H73.7148V113.416H77.4006V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 102.438H73.7148V106.096H77.4006V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 98.7812H73.7148V102.44H77.4006V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 95.1211H73.7148V98.7796H77.4006V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 91.4648H73.7148V95.1234H77.4006V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 87.8047H73.7148V91.4632H77.4006V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 76.8281H73.7148V80.4867H77.4006V76.8281Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 73.1719H73.7148V76.8304H77.4006V73.1719Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 69.5117H73.7148V73.1703H77.4006V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 65.8555H73.7148V69.514H77.4006V65.8555Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 54.8789H73.7148V58.5374H77.4006V54.8789Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4006 51.2188H73.7148V54.8773H77.4006V51.2188Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 131.707H70.0273V135.366H73.7131V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 128.047H70.0273V131.705H73.7131V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 124.391H70.0273V128.049H73.7131V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 120.73H70.0273V124.389H73.7131V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 117.074H70.0273V120.733H73.7131V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 113.414H70.0273V117.073H73.7131V113.414Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 109.758H70.0273V113.416H73.7131V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 106.098H70.0273V109.756H73.7131V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 102.438H70.0273V106.096H73.7131V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 98.7812H70.0273V102.44H73.7131V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 95.1211H70.0273V98.7796H73.7131V95.1211Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 91.4648H70.0273V95.1234H73.7131V91.4648Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 87.8047H70.0273V91.4632H73.7131V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 84.1445H70.0273V87.8031H73.7131V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 76.8281H70.0273V80.4867H73.7131V76.8281Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 73.1719H70.0273V76.8304H73.7131V73.1719Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 69.5117H70.0273V73.1703H73.7131V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 65.8555H70.0273V69.514H73.7131V65.8555Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 62.1953H70.0273V65.8538H73.7131V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 54.8789H70.0273V58.5374H73.7131V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 51.2188H70.0273V54.8773H73.7131V51.2188Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 47.5625H70.0273V51.221H73.7131V47.5625Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7131 32.9258H70.0273V36.5843H73.7131V32.9258Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 131.707H66.3438V135.366H70.0295V131.707Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 128.047H66.3438V131.705H70.0295V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 124.391H66.3438V128.049H70.0295V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 120.73H66.3438V124.389H70.0295V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 117.074H66.3438V120.733H70.0295V117.074Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 113.414H66.3438V117.073H70.0295V113.414Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 109.758H66.3438V113.416H70.0295V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 106.098H66.3438V109.756H70.0295V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 102.438H66.3438V106.096H70.0295V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 98.7812H66.3438V102.44H70.0295V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 95.1211H66.3438V98.7796H70.0295V95.1211Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 91.4648H66.3438V95.1234H70.0295V91.4648Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 87.8047H66.3438V91.4632H70.0295V87.8047Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 84.1445H66.3438V87.8031H70.0295V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 80.4883H66.3438V84.1468H70.0295V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 76.8281H66.3438V80.4867H70.0295V76.8281Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 73.1719H66.3438V76.8304H70.0295V73.1719Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 69.5117H66.3438V73.1703H70.0295V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 65.8555H66.3438V69.514H70.0295V65.8555Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 62.1953H66.3438V65.8538H70.0295V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 54.8789H66.3438V58.5374H70.0295V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 51.2188H66.3438V54.8773H70.0295V51.2188Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 47.5625H66.3438V51.221H70.0295V47.5625Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 43.9023H66.3438V47.5609H70.0295V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 36.5859H66.3438V40.2445H70.0295V36.5859Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0295 32.9258H66.3438V36.5843H70.0295V32.9258Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 131.707H62.6562V135.366H66.342V131.707Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 128.047H62.6562V131.705H66.342V128.047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 124.391H62.6562V128.049H66.342V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 120.73H62.6562V124.389H66.342V120.73Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 117.074H62.6562V120.733H66.342V117.074Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 113.414H62.6562V117.073H66.342V113.414Z",
    fill: "#80D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 109.758H62.6562V113.416H66.342V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 106.098H62.6562V109.756H66.342V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 102.438H62.6562V106.096H66.342V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 98.7812H62.6562V102.44H66.342V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 95.1211H62.6562V98.7796H66.342V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 91.4648H62.6562V95.1234H66.342V91.4648Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 87.8047H62.6562V91.4632H66.342V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 84.1445H62.6562V87.8031H66.342V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 80.4883H62.6562V84.1468H66.342V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 76.8281H62.6562V80.4867H66.342V76.8281Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 73.1719H62.6562V76.8304H66.342V73.1719Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 69.5117H62.6562V73.1703H66.342V69.5117Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 65.8555H62.6562V69.514H66.342V65.8555Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 62.1953H62.6562V65.8538H66.342V62.1953Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 58.5352H62.6562V62.1937H66.342V58.5352Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 54.8789H62.6562V58.5374H66.342V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 51.2188H62.6562V54.8773H66.342V51.2188Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 47.5625H62.6562V51.221H66.342V47.5625Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 43.9023H62.6562V47.5609H66.342V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 36.5859H62.6562V40.2445H66.342V36.5859Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 32.9258H62.6562V36.5843H66.342V32.9258Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.342 29.2695H62.6562V32.9281H66.342V29.2695Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 146.34H58.9727V149.998H62.6584V146.34Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 142.684H58.9727V146.342H62.6584V142.684Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 139.023H58.9727V142.682H62.6584V139.023Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 135.367H58.9727V139.026H62.6584V135.367Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 131.707H58.9727V135.366H62.6584V131.707Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 128.047H58.9727V131.705H62.6584V128.047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 124.391H58.9727V128.049H62.6584V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 120.73H58.9727V124.389H62.6584V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 117.074H58.9727V120.733H62.6584V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 113.414H58.9727V117.073H62.6584V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 109.758H58.9727V113.416H62.6584V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 106.098H58.9727V109.756H62.6584V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 102.438H58.9727V106.096H62.6584V102.438Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 98.7812H58.9727V102.44H62.6584V98.7812Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 95.1211H58.9727V98.7796H62.6584V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 91.4648H58.9727V95.1234H62.6584V91.4648Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 87.8047H58.9727V91.4632H62.6584V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 84.1445H58.9727V87.8031H62.6584V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 80.4883H58.9727V84.1468H62.6584V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 76.8281H58.9727V80.4867H62.6584V76.8281Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 73.1719H58.9727V76.8304H62.6584V73.1719Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 69.5117H58.9727V73.1703H62.6584V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 65.8555H58.9727V69.514H62.6584V65.8555Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 62.1953H58.9727V65.8538H62.6584V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 58.5352H58.9727V62.1937H62.6584V58.5352Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 54.8789H58.9727V58.5374H62.6584V54.8789Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 51.2188H58.9727V54.8773H62.6584V51.2188Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 47.5625H58.9727V51.221H62.6584V47.5625Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 43.9023H58.9727V47.5609H62.6584V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 40.2422H58.9727V43.9007H62.6584V40.2422Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 36.5859H58.9727V40.2445H62.6584V36.5859Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 32.9258H58.9727V36.5843H62.6584V32.9258Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 29.2695H58.9727V32.9281H62.6584V29.2695Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6584 25.6094H58.9727V29.2679H62.6584V25.6094Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 146.34H55.2852V149.998H58.9709V146.34Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 142.684H55.2852V146.342H58.9709V142.684Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 139.023H55.2852V142.682H58.9709V139.023Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 135.367H55.2852V139.026H58.9709V135.367Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 131.707H55.2852V135.366H58.9709V131.707Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 128.047H55.2852V131.705H58.9709V128.047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 124.391H55.2852V128.049H58.9709V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 120.73H55.2852V124.389H58.9709V120.73Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 117.074H55.2852V120.733H58.9709V117.074Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 113.414H55.2852V117.073H58.9709V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 109.758H55.2852V113.416H58.9709V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 106.098H55.2852V109.756H58.9709V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 102.438H55.2852V106.096H58.9709V102.438Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 98.7812H55.2852V102.44H58.9709V98.7812Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 95.1211H55.2852V98.7796H58.9709V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 91.4648H55.2852V95.1234H58.9709V91.4648Z",
    fill: "#80D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 87.8047H55.2852V91.4632H58.9709V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 84.1445H55.2852V87.8031H58.9709V84.1445Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 80.4883H55.2852V84.1468H58.9709V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 76.8281H55.2852V80.4867H58.9709V76.8281Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 73.1719H55.2852V76.8304H58.9709V73.1719Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 69.5117H55.2852V73.1703H58.9709V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 65.8555H55.2852V69.514H58.9709V65.8555Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 62.1953H55.2852V65.8538H58.9709V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 58.5352H55.2852V62.1937H58.9709V58.5352Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 54.8789H55.2852V58.5374H58.9709V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 51.2188H55.2852V54.8773H58.9709V51.2188Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 47.5625H55.2852V51.221H58.9709V47.5625Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 43.9023H55.2852V47.5609H58.9709V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 40.2422H55.2852V43.9007H58.9709V40.2422Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 36.5859H55.2852V40.2445H58.9709V36.5859Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 32.9258H55.2852V36.5843H58.9709V32.9258Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 29.2695H55.2852V32.9281H58.9709V29.2695Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 25.6094H55.2852V29.2679H58.9709V25.6094Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 21.9531H55.2852V25.6117H58.9709V21.9531Z",
    fill: "#80D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 18.293H55.2852V21.9515H58.9709V18.293Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 14.6328H55.2852V18.2913H58.9709V14.6328Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9709 3.66016H55.2852V7.31869H58.9709V3.66016Z",
    fill: "#F9ED94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 146.34H51.6016V149.998H55.2873V146.34Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 142.684H51.6016V146.342H55.2873V142.684Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 139.023H51.6016V142.682H55.2873V139.023Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 135.367H51.6016V139.026H55.2873V135.367Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 131.707H51.6016V135.366H55.2873V131.707Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 128.047H51.6016V131.705H55.2873V128.047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 124.391H51.6016V128.049H55.2873V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 120.73H51.6016V124.389H55.2873V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 117.074H51.6016V120.733H55.2873V117.074Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 113.414H51.6016V117.073H55.2873V113.414Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 109.758H51.6016V113.416H55.2873V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 106.098H51.6016V109.756H55.2873V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 102.438H51.6016V106.096H55.2873V102.438Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 98.7812H51.6016V102.44H55.2873V98.7812Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 95.1211H51.6016V98.7796H55.2873V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 91.4648H51.6016V95.1234H55.2873V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 87.8047H51.6016V91.4632H55.2873V87.8047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 84.1445H51.6016V87.8031H55.2873V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 80.4883H51.6016V84.1468H55.2873V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 76.8281H51.6016V80.4867H55.2873V76.8281Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 73.1719H51.6016V76.8304H55.2873V73.1719Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 69.5117H51.6016V73.1703H55.2873V69.5117Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 65.8555H51.6016V69.514H55.2873V65.8555Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 62.1953H51.6016V65.8538H55.2873V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 58.5352H51.6016V62.1937H55.2873V58.5352Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 54.8789H51.6016V58.5374H55.2873V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 51.2188H51.6016V54.8773H55.2873V51.2188Z",
    fill: "#80D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 47.5625H51.6016V51.221H55.2873V47.5625Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 43.9023H51.6016V47.5609H55.2873V43.9023Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 40.2422H51.6016V43.9007H55.2873V40.2422Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 36.5859H51.6016V40.2445H55.2873V36.5859Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 32.9258H51.6016V36.5843H55.2873V32.9258Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 29.2695H51.6016V32.9281H55.2873V29.2695Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 25.6094H51.6016V29.2679H55.2873V25.6094Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 21.9531H51.6016V25.6117H55.2873V21.9531Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 18.293H51.6016V21.9515H55.2873V18.293Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 14.6328H51.6016V18.2913H55.2873V14.6328Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 10.9766H51.6016V14.6351H55.2873V10.9766Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 7.31641H51.6016V10.9749H55.2873V7.31641Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 3.66016H51.6016V7.31869H55.2873V3.66016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2873 0H51.6016V3.65854H55.2873V0Z",
    fill: "#F9ED94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 146.34H47.9141V149.998H51.5998V146.34Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 142.684H47.9141V146.342H51.5998V142.684Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 139.023H47.9141V142.682H51.5998V139.023Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 135.367H47.9141V139.026H51.5998V135.367Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 131.707H47.9141V135.366H51.5998V131.707Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 128.047H47.9141V131.705H51.5998V128.047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 124.391H47.9141V128.049H51.5998V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 120.73H47.9141V124.389H51.5998V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 117.074H47.9141V120.733H51.5998V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 113.414H47.9141V117.073H51.5998V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 109.758H47.9141V113.416H51.5998V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 106.098H47.9141V109.756H51.5998V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 102.438H47.9141V106.096H51.5998V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 98.7812H47.9141V102.44H51.5998V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 95.1211H47.9141V98.7796H51.5998V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 91.4648H47.9141V95.1234H51.5998V91.4648Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 87.8047H47.9141V91.4632H51.5998V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 84.1445H47.9141V87.8031H51.5998V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 80.4883H47.9141V84.1468H51.5998V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 76.8281H47.9141V80.4867H51.5998V76.8281Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 73.1719H47.9141V76.8304H51.5998V73.1719Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 69.5117H47.9141V73.1703H51.5998V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 65.8555H47.9141V69.514H51.5998V65.8555Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 62.1953H47.9141V65.8538H51.5998V62.1953Z",
    fill: "#80D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 58.5352H47.9141V62.1937H51.5998V58.5352Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 54.8789H47.9141V58.5374H51.5998V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 51.2188H47.9141V54.8773H51.5998V51.2188Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 47.5625H47.9141V51.221H51.5998V47.5625Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 43.9023H47.9141V47.5609H51.5998V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 40.2422H47.9141V43.9007H51.5998V40.2422Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 36.5859H47.9141V40.2445H51.5998V36.5859Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 32.9258H47.9141V36.5843H51.5998V32.9258Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 29.2695H47.9141V32.9281H51.5998V29.2695Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 25.6094H47.9141V29.2679H51.5998V25.6094Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 21.9531H47.9141V25.6117H51.5998V21.9531Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 18.293H47.9141V21.9515H51.5998V18.293Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 14.6328H47.9141V18.2913H51.5998V14.6328Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5998 3.66016H47.9141V7.31869H51.5998V3.66016Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 146.34H44.2305V149.998H47.9162V146.34Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 142.684H44.2305V146.342H47.9162V142.684Z",
    fill: "#613926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 139.023H44.2305V142.682H47.9162V139.023Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 135.367H44.2305V139.026H47.9162V135.367Z",
    fill: "#42210B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 131.707H44.2305V135.366H47.9162V131.707Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 128.047H44.2305V131.705H47.9162V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 124.391H44.2305V128.049H47.9162V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 120.73H44.2305V124.389H47.9162V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 117.074H44.2305V120.733H47.9162V117.074Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 113.414H44.2305V117.073H47.9162V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 109.758H44.2305V113.416H47.9162V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 106.098H44.2305V109.756H47.9162V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 102.438H44.2305V106.096H47.9162V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 98.7812H44.2305V102.44H47.9162V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 95.1211H44.2305V98.7796H47.9162V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 91.4648H44.2305V95.1234H47.9162V91.4648Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 87.8047H44.2305V91.4632H47.9162V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 84.1445H44.2305V87.8031H47.9162V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 80.4883H44.2305V84.1468H47.9162V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 76.8281H44.2305V80.4867H47.9162V76.8281Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 73.1719H44.2305V76.8304H47.9162V73.1719Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 69.5117H44.2305V73.1703H47.9162V69.5117Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 65.8555H44.2305V69.514H47.9162V65.8555Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 62.1953H44.2305V65.8538H47.9162V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 58.5352H44.2305V62.1937H47.9162V58.5352Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 54.8789H44.2305V58.5374H47.9162V54.8789Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 51.2188H44.2305V54.8773H47.9162V51.2188Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 47.5625H44.2305V51.221H47.9162V47.5625Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 43.9023H44.2305V47.5609H47.9162V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 40.2422H44.2305V43.9007H47.9162V40.2422Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 36.5859H44.2305V40.2445H47.9162V36.5859Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 32.9258H44.2305V36.5843H47.9162V32.9258Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 29.2695H44.2305V32.9281H47.9162V29.2695Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9162 25.6094H44.2305V29.2679H47.9162V25.6094Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 131.707H40.543V135.366H44.2287V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 128.047H40.543V131.705H44.2287V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 124.391H40.543V128.049H44.2287V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 120.73H40.543V124.389H44.2287V120.73Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 117.074H40.543V120.733H44.2287V117.074Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 113.414H40.543V117.073H44.2287V113.414Z",
    fill: "#F96E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 109.758H40.543V113.416H44.2287V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 106.098H40.543V109.756H44.2287V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 102.438H40.543V106.096H44.2287V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 98.7812H40.543V102.44H44.2287V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 95.1211H40.543V98.7796H44.2287V95.1211Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 91.4648H40.543V95.1234H44.2287V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 87.8047H40.543V91.4632H44.2287V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 84.1445H40.543V87.8031H44.2287V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 80.4883H40.543V84.1468H44.2287V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 76.8281H40.543V80.4867H44.2287V76.8281Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 73.1719H40.543V76.8304H44.2287V73.1719Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 69.5117H40.543V73.1703H44.2287V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 65.8555H40.543V69.514H44.2287V65.8555Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 62.1953H40.543V65.8538H44.2287V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 58.5352H40.543V62.1937H44.2287V58.5352Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 54.8789H40.543V58.5374H44.2287V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 51.2188H40.543V54.8773H44.2287V51.2188Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 47.5625H40.543V51.221H44.2287V47.5625Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 43.9023H40.543V47.5609H44.2287V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 36.5859H40.543V40.2445H44.2287V36.5859Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 32.9258H40.543V36.5843H44.2287V32.9258Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2287 29.2695H40.543V32.9281H44.2287V29.2695Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 131.707H36.8555V135.366H40.5412V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 128.047H36.8555V131.705H40.5412V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 124.391H36.8555V128.049H40.5412V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 120.73H36.8555V124.389H40.5412V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 117.074H36.8555V120.733H40.5412V117.074Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 113.414H36.8555V117.073H40.5412V113.414Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 109.758H36.8555V113.416H40.5412V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 106.098H36.8555V109.756H40.5412V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 102.438H36.8555V106.096H40.5412V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 98.7812H36.8555V102.44H40.5412V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 95.1211H36.8555V98.7796H40.5412V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 91.4648H36.8555V95.1234H40.5412V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 87.8047H36.8555V91.4632H40.5412V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 84.1445H36.8555V87.8031H40.5412V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 80.4883H36.8555V84.1468H40.5412V80.4883Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 76.8281H36.8555V80.4867H40.5412V76.8281Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 73.1719H36.8555V76.8304H40.5412V73.1719Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 69.5117H36.8555V73.1703H40.5412V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 65.8555H36.8555V69.514H40.5412V65.8555Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 62.1953H36.8555V65.8538H40.5412V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 54.8789H36.8555V58.5374H40.5412V54.8789Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 51.2188H36.8555V54.8773H40.5412V51.2188Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 47.5625H36.8555V51.221H40.5412V47.5625Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 43.9023H36.8555V47.5609H40.5412V43.9023Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 36.5859H36.8555V40.2445H40.5412V36.5859Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5412 32.9258H36.8555V36.5843H40.5412V32.9258Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 131.707H33.1719V135.366H36.8576V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 128.047H33.1719V131.705H36.8576V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 124.391H33.1719V128.049H36.8576V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 120.73H33.1719V124.389H36.8576V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 117.074H33.1719V120.733H36.8576V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 113.414H33.1719V117.073H36.8576V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 109.758H33.1719V113.416H36.8576V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 106.098H33.1719V109.756H36.8576V106.098Z",
    fill: "#1E4D10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 102.438H33.1719V106.096H36.8576V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 98.7812H33.1719V102.44H36.8576V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 95.1211H33.1719V98.7796H36.8576V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 91.4648H33.1719V95.1234H36.8576V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 87.8047H33.1719V91.4632H36.8576V87.8047Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 84.1445H33.1719V87.8031H36.8576V84.1445Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 76.8281H33.1719V80.4867H36.8576V76.8281Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 73.1719H33.1719V76.8304H36.8576V73.1719Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 69.5117H33.1719V73.1703H36.8576V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 65.8555H33.1719V69.514H36.8576V65.8555Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 62.1953H33.1719V65.8538H36.8576V62.1953Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 54.8789H33.1719V58.5374H36.8576V54.8789Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 51.2188H33.1719V54.8773H36.8576V51.2188Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 47.5625H33.1719V51.221H36.8576V47.5625Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8576 32.9258H33.1719V36.5843H36.8576V32.9258Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 131.707H29.4844V135.366H33.1701V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 128.047H29.4844V131.705H33.1701V128.047Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 124.391H29.4844V128.049H33.1701V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 120.73H29.4844V124.389H33.1701V120.73Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 117.074H29.4844V120.733H33.1701V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 113.414H29.4844V117.073H33.1701V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 109.758H29.4844V113.416H33.1701V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 102.438H29.4844V106.096H33.1701V102.438Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 98.7812H29.4844V102.44H33.1701V98.7812Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 95.1211H29.4844V98.7796H33.1701V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 91.4648H29.4844V95.1234H33.1701V91.4648Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 87.8047H29.4844V91.4632H33.1701V87.8047Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 76.8281H29.4844V80.4867H33.1701V76.8281Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 73.1719H29.4844V76.8304H33.1701V73.1719Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 69.5117H29.4844V73.1703H33.1701V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 65.8555H29.4844V69.514H33.1701V65.8555Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 54.8789H29.4844V58.5374H33.1701V54.8789Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1701 51.2188H29.4844V54.8773H33.1701V51.2188Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 131.707H25.8008V135.366H29.4865V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 128.047H25.8008V131.705H29.4865V128.047Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 124.391H25.8008V128.049H29.4865V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 120.73H25.8008V124.389H29.4865V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 117.074H25.8008V120.733H29.4865V117.074Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 113.414H25.8008V117.073H29.4865V113.414Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 109.758H25.8008V113.416H29.4865V109.758Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 102.438H25.8008V106.096H29.4865V102.438Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 98.7812H25.8008V102.44H29.4865V98.7812Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 95.1211H25.8008V98.7796H29.4865V95.1211Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 91.4648H25.8008V95.1234H29.4865V91.4648Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 87.8047H25.8008V91.4632H29.4865V87.8047Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 73.1719H25.8008V76.8304H29.4865V73.1719Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 69.5117H25.8008V73.1703H29.4865V69.5117Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 65.8555H25.8008V69.514H29.4865V65.8555Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4865 51.2188H25.8008V54.8773H29.4865V51.2188Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 131.707H22.1133V135.366H25.799V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 128.047H22.1133V131.705H25.799V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 124.391H22.1133V128.049H25.799V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 120.73H22.1133V124.389H25.799V120.73Z",
    fill: "#80D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 117.074H22.1133V120.733H25.799V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 113.414H22.1133V117.073H25.799V113.414Z",
    fill: "#376D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 102.438H22.1133V106.096H25.799V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 98.7812H22.1133V102.44H25.799V98.7812Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 95.1211H22.1133V98.7796H25.799V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 91.4648H22.1133V95.1234H25.799V91.4648Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 73.1719H22.1133V76.8304H25.799V73.1719Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.799 69.5117H22.1133V73.1703H25.799V69.5117Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 131.707H18.4297V135.366H22.1154V131.707Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 128.047H18.4297V131.705H22.1154V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 124.391H18.4297V128.049H22.1154V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 120.73H18.4297V124.389H22.1154V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 117.074H18.4297V120.733H22.1154V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 113.414H18.4297V117.073H22.1154V113.414Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 102.438H18.4297V106.096H22.1154V102.438Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 98.7812H18.4297V102.44H22.1154V98.7812Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 95.1211H18.4297V98.7796H22.1154V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 91.4648H18.4297V95.1234H22.1154V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1154 69.5117H18.4297V73.1703H22.1154V69.5117Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 128.047H14.7422V131.705H18.4279V128.047Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 124.391H14.7422V128.049H18.4279V124.391Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 120.73H14.7422V124.389H18.4279V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 117.074H14.7422V120.733H18.4279V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 98.7812H14.7422V102.44H18.4279V98.7812Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 95.1211H14.7422V98.7796H18.4279V95.1211Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4279 91.4648H14.7422V95.1234H18.4279V91.4648Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7443 128.047H11.0586V131.705H14.7443V128.047Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7443 124.391H11.0586V128.049H14.7443V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7443 120.73H11.0586V124.389H14.7443V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7443 117.074H11.0586V120.733H14.7443V117.074Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7443 98.7812H11.0586V102.44H14.7443V98.7812Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7443 95.1211H11.0586V98.7796H14.7443V95.1211Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0568 124.391H7.37109V128.049H11.0568V124.391Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0568 120.73H7.37109V124.389H11.0568V120.73Z",
    fill: "#508D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0568 95.1211H7.37109V98.7796H11.0568V95.1211Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37321 124.391H3.6875V128.049H7.37321V124.391Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37321 120.73H3.6875V124.389H7.37321V120.73Z",
    fill: "#E3FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68571 120.73H0V124.389H3.68571V120.73Z",
    fill: "#B2EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.998 146.34H125.312V149.998H128.998V146.34Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.998 142.684H125.312V146.342H128.998V142.684Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.998 139.023H125.312V142.682H128.998V139.023Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.998 135.367H125.312V139.026H128.998V135.367Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.315 146.34H121.629V149.998H125.315V146.34Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.315 142.684H121.629V146.342H125.315V142.684Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.315 139.023H121.629V142.682H125.315V139.023Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.315 135.367H121.629V139.026H125.315V135.367Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.315 131.707H121.629V135.366H125.315V131.707Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.627 146.34H117.941V149.998H121.627V146.34Z",
    fill: "#F2BE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.627 142.684H117.941V146.342H121.627V142.684Z",
    fill: "#F2BE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.627 139.023H117.941V142.682H121.627V139.023Z",
    fill: "#F2BE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.627 135.367H117.941V139.026H121.627V135.367Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.944 146.34H114.258V149.998H117.944V146.34Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.944 142.684H114.258V146.342H117.944V142.684Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.944 139.023H114.258V142.682H117.944V139.023Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.944 135.367H114.258V139.026H117.944V135.367Z",
    fill: "#FF0003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.944 131.707H114.258V135.366H117.944V131.707Z",
    fill: "#F3DB29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.256 146.34H110.57V149.998H114.256V146.34Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.256 142.684H110.57V146.342H114.256V142.684Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.256 139.023H110.57V142.682H114.256V139.023Z",
    fill: "#D30403"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.256 135.367H110.57V139.026H114.256V135.367Z",
    fill: "#FF0003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_2588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNyTree);
export default __webpack_public_path__ + "static/media/NY-tree.536087bab331714b35f0b71fbb0f1fc0.svg";
export { ForwardRef as ReactComponent };